import axios from 'axios';
import Response from '@/domain/response.entity';
import Pagination from '@/domain/pagination.entity';
import Customer from '../entity/customer.entity';

export default class CustomerService {
  public static list(pagination: Pagination, name: string) {
    return axios.get('/api/v1/customers', {
      params: {
        page: pagination.page - 1,
        size: pagination.itemsPerPage,
        sortBy: pagination.arrangeSortBy,
        name,
      },
    })
      .then((response: any) => Response.of(response.data))
  }

  public static getByTradingNameOrName(pagination: Pagination,
    fetchName: string, fetchParam: string, businessUnitId: string) {
    return axios.get('/api/v1/customers', {
      params: {
        page: pagination.page - 1,
        size: pagination.itemsPerPage,
        sortBy: pagination.arrangeSortBy,
        [`${fetchParam}`]: fetchName,
        businessUnitId,
      },
    })
      .then((response: any) => Response.of(response.data))
  }

  public static getByTradingNameOrNameOrDocument(pagination: Pagination,
    fetchName: string, fetchParam: string, businessUnitId: string) {
    return axios.get('/api/v1/customers', {
      params: {
        page: pagination.page - 1,
        size: pagination.itemsPerPage,
        sortBy: pagination.arrangeSortBy,
        [`${fetchParam}`]: fetchName,
        businessUnitId,
      },
    })
      .then((response: any) => Response.of(response.data))
  }

  public static getAllByNameOrTradingName(
    field: string,
    value: string,
    businessUnitId: string,
  ): Promise<Customer[]> {
    return axios.get('/api/v1/customers/all', {
      params: {
        [field]: value,
        businessUnitId,
      },
    })
      .then((response: any) => Customer.ofList(response.data))
  }
}
